import { Box } from '@mui/material'
import { FC } from 'react'
import { Route, Routes } from 'react-router-dom'
import { GlobalSearch, PrivateFoundations, SmallBusiness, Federal } from './subComponents'

export const BrowseGrants: FC = () => {
  return (
    <Box width="100%">
      <Routes>
        <Route index path="/" element={<GlobalSearch />} />

        <Route path="/federal" element={<Federal />} />
        <Route path="/smallBusiness" element={<SmallBusiness />} />
        <Route path="/privateFoundations" element={<PrivateFoundations />} />
      </Routes>
    </Box>
  )
}
